var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
class Accordeon {
    constructor(element) {
        this.htmlElement = element;
        this.toggleButtonElement = $(this.htmlElement).find('.button-toggle-accordeon');
        $(this.htmlElement).find('.accordeon-title').on('click', (event, item) => {
            if (event.target.tagName == 'A')
                return;
            this.toggleItem(item);
        });
        this.toggleButtonElement.on('click', (event, button) => {
            event.preventDefault();
            $(button).toggleClass('opened').parents('.module-accordeon').find('.accordeon-title').forEach((item) => {
                if ($(button).hasClass('opened')) {
                    this.openItem(item);
                }
                else {
                    this.closeItem(item);
                }
            });
        });
    }
    toggleItem(item) {
        if ($(item).next().get(0).style.maxHeight == '') {
            this.openItem(item);
        }
        else {
            this.closeItem(item);
        }
    }
    openItem(item) {
        $(item).addClass('opened').next().addClass('opened').get(0).style.maxHeight = ($(item).next().get(0).scrollHeight + 32) + 'px';
        this.updateToggleButton();
    }
    closeItem(item) {
        $(item).removeClass('opened').next().removeClass('opened').get(0).style.maxHeight = '';
        this.updateToggleButton();
    }
    updateToggleButton() {
        var openedItemCount = 0;
        $(this.htmlElement).find('.accordeon-title').forEach((item) => {
            if ($(item).hasClass('opened'))
                openedItemCount++;
        });
        if (openedItemCount == 0) {
            this.toggleButtonElement.removeClass('opened');
        }
        else if (openedItemCount == $(this.htmlElement).find('.accordeon-item ').length) {
            this.toggleButtonElement.addClass('opened');
        }
    }
}
export class AccordeonComponent extends Component {
    constructor() {
        super('AccordeonComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.module-accordeon').forEach((item) => {
                new Accordeon(item);
            });
            this.success();
        });
    }
}
